export default "__VITE_ASSET__CIkjb1pg__"